import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function About() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formMessage, setFormMessage] = useState('');

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = (formData.get('website_alt') as string || '').trim();
    if (honeypot) {
      setFormStatus('success');
      setFormMessage('提交成功，我们会尽快与您联系！');
      form.reset();
      return;
    }
    setFormStatus('success');
    setFormMessage('提交成功，我们会尽快与您联系！');
    form.reset();
  };

  const aboutSchema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "name": "韩漫画网",
        "url": "http://coffeemate.cn/",
        "description": "韩漫画网提供韩漫在线阅读服务，包含免费的韩国漫画和无删减下拉式韩漫大全",
        "foundingDate": "2023",
        "contactPoint": {
          "@type": "ContactPoint",
          "contactType": "business cooperation",
          "email": "hello@coffeemate.cn",
          "availableLanguage": ["Chinese"]
        },
        "sameAs": ["http://coffeemate.cn/", "http://coffeemate.cn/hanmanhua"]
      },
      {
        "@type": "WebPage",
        "name": "关于我们 - 韩漫画网",
        "url": "http://coffeemate.cn/about",
        "description": "了解韩漫画网品牌故事、平台数据、商业合作联系方式",
        "isPartOf": { "@type": "WebSite", "name": "韩漫画网", "url": "http://coffeemate.cn/" }
      },
      {
        "@type": "BreadcrumbList",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "name": "首页", "item": "http://coffeemate.cn/" },
          { "@type": "ListItem", "position": 2, "name": "关于我们", "item": "http://coffeemate.cn/about" }
        ]
      },
      {
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "韩漫画网提供什么类型的韩国漫画？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "韩漫画网提供恋爱、动作、奇幻、悬疑、喜剧、剧情等多种类型的韩国漫画，覆盖热门连载和经典完结作品，所有内容均为无删减完整版。"
            }
          },
          {
            "@type": "Question",
            "name": "韩漫画网需要付费吗？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "韩漫画网所有漫画内容均为免费提供，您无需支付任何费用即可享受无删减下拉式韩漫阅读体验。"
            }
          },
          {
            "@type": "Question",
            "name": "如何与韩漫画网进行商务合作？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "您可以通过关于我们页面的商务合作表单提交合作意向，或发送邮件至 hello@coffeemate.cn，我们的商务团队会在3个工作日内与您联系。"
            }
          },
          {
            "@type": "Question",
            "name": "韩漫画网的漫画多久更新一次？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "韩漫画网每日更新连载中的韩漫作品，确保读者能在第一时间阅读到最新章节。热门作品的更新频率通常为每周1-2话。"
            }
          }
        ]
      }
    ]
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutSchema) }} />
      <Navbar />

      <main className="pt-16">
        <section className="relative w-full min-h-[360px] md:min-h-[440px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20with%20library%20full%20of%20comic%20books%2C%20warm%20and%20inviting%20atmosphere%2C%20artistic%20webtoon%20style%2C%20bookshelves%20with%20colorful%20comic%20volumes%2C%20cozy%20reading%20nook%2C%20soft%20warm%20lighting%2C%20creative%20and%20inspiring%20space%2C%20manhwa%20aesthetic&width=1600&height=900&seq=about-hero-01&orientation=landscape"
            alt="关于韩漫画网"
            title="关于我们 - 韩漫画网"
            className="absolute inset-0 w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
          <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-black text-background-50 font-heading">关于我们</h1>
            <p className="mt-4 text-sm md:text-base text-background-300 max-w-xl mx-auto">
              了解韩漫画网的品牌故事与使命
            </p>
          </div>
        </section>

        <section className="py-10 md:py-14 bg-secondary-50">
          <div className="max-w-5xl mx-auto px-4 md:px-6">
            <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-10" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-500 transition-colors">首页</Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-foreground-800 font-medium">关于我们</span>
            </nav>

            <div className="mb-12">
              <span className="text-xs text-foreground-400 uppercase tracking-wider">About Hanmanhua</span>
              <div className="mt-6 max-w-3xl">
                <p className="text-lg md:text-xl text-foreground-800 leading-relaxed font-heading">
                  韩漫画网成立于2023年，致力于为中文读者打造最优质的韩漫在线阅读平台。我们相信每一部韩国漫画都承载着创作者的心血与读者的期待。通过提供无删减、完整版的韩漫作品，我们希望让更多中文读者能够原汁原味地感受韩漫的独特魅力。
                </p>
                <p className="mt-4 text-base text-foreground-600 leading-relaxed">
                  从恋爱到动作，从奇幻到悬疑，韩漫画网涵盖了丰富的漫画类型。我们每日更新热门连载作品，确保读者能够第一时间阅读到最新章节。平台所有内容均为免费提供，无需任何付费订阅。
                </p>
              </div>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              <div className="text-center p-6 rounded-lg bg-background-50">
                <div className="text-3xl md:text-4xl font-black text-foreground-900 font-heading">120<span className="text-primary-500">+</span></div>
                <p className="text-xs text-foreground-500 mt-2">漫画作品总数</p>
              </div>
              <div className="text-center p-6 rounded-lg bg-background-50">
                <div className="text-3xl md:text-4xl font-black text-foreground-900 font-heading">500<span className="text-primary-500">万+</span></div>
                <p className="text-xs text-foreground-500 mt-2">累计读者用户</p>
              </div>
              <div className="text-center p-6 rounded-lg bg-background-50">
                <div className="text-3xl md:text-4xl font-black text-foreground-900 font-heading">99<span className="text-primary-500">%</span></div>
                <p className="text-xs text-foreground-500 mt-2">用户好评率</p>
              </div>
              <div className="text-center p-6 rounded-lg bg-background-50">
                <div className="text-3xl md:text-4xl font-black text-foreground-900 font-heading">30<span className="text-primary-500">+</span></div>
                <p className="text-xs text-foreground-500 mt-2">合作版权方</p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14 bg-background-50">
          <div className="max-w-5xl mx-auto px-4 md:px-6">
            <div className="flex flex-col md:flex-row gap-10 items-center">
              <div className="flex-1">
                <span className="inline-flex items-center gap-1.5 text-xs text-foreground-400 font-medium">
                  <span className="w-1.5 h-1.5 rounded-full bg-foreground-900"></span>
                  媒体评价
                </span>
                <blockquote className="mt-4 text-xl md:text-3xl font-heading text-foreground-900 leading-snug">
                  &ldquo;韩漫画网以其丰富的韩漫资源和优质的阅读体验，<br />
                  迅速成为中文韩漫爱好者<br />
                  的首选平台。&rdquo;
                </blockquote>
                <div className="mt-4 flex items-center gap-2">
                  <span className="text-sm font-semibold text-foreground-800">动漫中国周刊</span>
                  <span className="flex items-center gap-0.5 text-accent-500 text-xs">
                    <i className="ri-verified-badge-fill"></i>
                    已认证
                  </span>
                </div>
              </div>
              <div className="w-full md:w-[40%] h-64 md:h-80 rounded-lg overflow-hidden flex-shrink-0">
                <img
                  src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20creative%20team%20working%20together%2C%20diverse%20artists%20and%20editors%20collaborating%2C%20warm%20studio%20atmosphere%2C%20artistic%20webtoon%20style%2C%20creative%20workspace%20with%20drawing%20tablets%20and%20sketches%2C%20professional%20yet%20cozy%20vibe%2C%20simple%20background&width=600&height=800&seq=about-team-01&orientation=portrait"
                  alt="韩漫画网团队"
                  title="韩漫画网团队"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="relative w-full min-h-[500px] md:min-h-[560px] flex items-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20business%20handshake%20and%20partnership%2C%20professional%20collaboration%20scene%2C%20warm%20and%20trustworthy%20atmosphere%2C%20artistic%20webtoon%20style%2C%20modern%20office%20setting%20with%20creative%20elements%2C%20clean%20and%20professional%2C%20partnership%20and%20growth%20theme&width=1600&height=900&seq=about-cta-01&orientation=landscape"
            alt="商务合作"
            title="韩漫画网商务合作"
            className="absolute inset-0 w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>
          <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="max-w-lg">
              <h2 className="text-4xl md:text-6xl lg:text-7xl font-black text-background-50 font-heading leading-none">
                business
              </h2>
              <p className="mt-6 text-sm md:text-base text-background-300 leading-relaxed">
                欢迎版权方、创作者及商业伙伴与我们联系。
                <br />
                共同推动韩漫文化在华语世界的传播与发展。
              </p>
              <div className="mt-8" id="contact-form">
                {formStatus === 'success' ? (
                  <div className="bg-accent-500/20 border border-accent-400/40 rounded-lg p-5">
                    <p className="text-background-50 text-sm">{formMessage}</p>
                    <button
                      onClick={() => { setFormStatus('idle'); setFormMessage(''); }}
                      className="mt-3 text-xs text-background-300 hover:text-background-50 transition-colors cursor-pointer underline"
                    >
                      发送新消息
                    </button>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit} className="flex flex-col gap-3 max-w-md">
                    <input
                      type="text"
                      name="name"
                      placeholder="您的姓名"
                      required
                      className="px-4 py-3 bg-background-50/10 border border-background-300/30 rounded-lg text-sm text-background-50 placeholder:text-background-400 focus:outline-none focus:border-background-50/50"
                    />
                    <input
                      type="email"
                      name="email"
                      placeholder="您的邮箱"
                      required
                      className="px-4 py-3 bg-background-50/10 border border-background-300/30 rounded-lg text-sm text-background-50 placeholder:text-background-400 focus:outline-none focus:border-background-50/50"
                    />
                    <textarea
                      name="message"
                      placeholder="请描述您的合作意向..."
                      rows={3}
                      required
                      maxLength={500}
                      className="px-4 py-3 bg-background-50/10 border border-background-300/30 rounded-lg text-sm text-background-50 placeholder:text-background-400 focus:outline-none focus:border-background-50/50 resize-none"
                    ></textarea>
                    <input
                      type="text"
                      name="website_alt"
                      tabIndex={-1}
                      autoComplete="off"
                      aria-hidden="true"
                      readOnly
                      className="form-hp-text"
                    />
                    <button
                      type="submit"
                      className="w-full sm:w-auto self-start px-8 py-3 bg-background-50 hover:bg-background-100 text-foreground-900 font-semibold rounded-full transition-all whitespace-nowrap text-sm cursor-pointer"
                    >
                      提交合作意向 <i className="ri-arrow-right-line ml-2"></i>
                    </button>
                    {formStatus === 'error' && (
                      <p className="text-red-400 text-xs">{formMessage}</p>
                    )}
                  </form>
                )}
              </div>
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14 bg-background-100">
          <div className="max-w-5xl mx-auto px-4 md:px-6">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading mb-8 text-center">常见问题</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-3xl mx-auto">
              <div className="bg-background-50 rounded-lg p-5">
                <h4 className="text-sm font-semibold text-foreground-800 mb-2">韩漫画网提供什么类型的韩国漫画？</h4>
                <p className="text-xs text-foreground-600 leading-relaxed">韩漫画网提供恋爱、动作、奇幻、悬疑、喜剧、剧情等多种类型的韩国漫画，覆盖热门连载和经典完结作品，所有内容均为无删减完整版。</p>
              </div>
              <div className="bg-background-50 rounded-lg p-5">
                <h4 className="text-sm font-semibold text-foreground-800 mb-2">韩漫画网需要付费吗？</h4>
                <p className="text-xs text-foreground-600 leading-relaxed">韩漫画网所有漫画内容均为免费提供，您无需支付任何费用即可享受无删减下拉式韩漫阅读体验。</p>
              </div>
              <div className="bg-background-50 rounded-lg p-5">
                <h4 className="text-sm font-semibold text-foreground-800 mb-2">如何与韩漫画网进行商务合作？</h4>
                <p className="text-xs text-foreground-600 leading-relaxed">您可以通过本页面的商务合作表单提交合作意向，或发送邮件至 hello@coffeemate.cn，我们的商务团队会在3个工作日内与您联系。</p>
              </div>
              <div className="bg-background-50 rounded-lg p-5">
                <h4 className="text-sm font-semibold text-foreground-800 mb-2">韩漫画网的漫画多久更新一次？</h4>
                <p className="text-xs text-foreground-600 leading-relaxed">韩漫画网每日更新连载中的韩漫作品，确保读者能在第一时间阅读到最新章节。热门作品的更新频率通常为每周1-2话。</p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}